export default "__VITE_ASSET__CwEYam08__"